{
	"logo": "Logo",
	"fileUpload": "Clique ou arraste aqui para anexar",
	"noInformation": "Sem informações",
	"toggleProducts": "Não, apenas esse produto",
	"comingSoon": "Em breve"
}
